import { getDocumentById } from '@/api/Documents';
import { OrderType } from '@/constants/orders';
import { useQuery } from '@tanstack/react-query';

export const useGetDocumentById = ({
  documentId,
  companyId,
  documentableType = 'companies',
}: {
  documentId: number;
  companyId: number;
  documentableType?: OrderType | 'companies';
}) => {
  return useQuery({
    queryKey: [`get-document-by-id`, documentId],
    queryFn: () =>
      getDocumentById({
        documentableType: documentableType,
        documentableId: companyId,
        documentId: documentId,
      }),
  });
};
